function VisitCardAnonymizedVO(id, reconnaissance, physicalExamination, recommendations, diagnosisList, medicalProcedures,
                               visit, icfDiagnosis, laboratoryTestResults, attachments, otcDrugs) {
    this.id = id;

    this.visit = visit;
    this.reconnaissance = reconnaissance;
    this.physicalExamination = physicalExamination;
    this.recommendations = recommendations;
    this.diagnosisList = diagnosisList;
    this.medicalProcedures = medicalProcedures;
    this.icfDiagnosis = icfDiagnosis;
    this.laboratoryTestResults = laboratoryTestResults;
    this.attachments = attachments;
    this.otcDrugs = otcDrugs;

    var _typeContext = {
        sickLeave: SickLeaveVO,
        diagnosisList: DiagnosisVO,
        medicalProcedures: MedicalProcedureVO,
        visit: VisitAnonymizedVO,
        prescriptions: PrescriptionVO,
        attachments: AttachmentVO,
        referrals: ReferralVO,
        otcDrugs: OTCDrugVO,
        icfDiagnosis: ICFDiagnosisVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
